import { createSlice } from '@reduxjs/toolkit';
import { loadUserDetails } from '../../utils/user.utils';

const initialState = {
    userInfos: loadUserDetails(),
};

export const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        setUserInfos: (state, action) => {
            state.userInfos = action.payload;
        },
        clearUserInfos: (state) => {
            state.userInfos = null;
        },
    },
});

export const getUserInfos = (state) => state.authState.userInfos

export const { setUserInfos, clearUserInfos } = authSlice.actions;
export default authSlice.reducer;